var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V16.2676C13.5978 16.6134 14 17.2597 14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18C10 17.2597 10.4022 16.6134 11 16.2676V9Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15V5C8 4.78832 8.02575 4.57525 8.06048 4.36685C8.11827 4.02011 8.23572 3.5425 8.48057 3.05279C8.72739 2.55916 9.11331 2.03511 9.71093 1.6367C10.3148 1.23412 11.075 1 12 1C12.925 1 13.6852 1.23412 14.2891 1.6367C14.8867 2.03511 15.2726 2.55916 15.5194 3.05279C15.7643 3.5425 15.8817 4.02011 15.9395 4.36685C15.9742 4.57498 15.9996 4.78759 16 4.99899V15C16.2821 15.3762 16.5116 15.7926 16.6793 16.2383C17.0608 17.2514 17.1031 18.3609 16.8 19.4001C16.4969 20.4393 15.8647 21.3521 14.9984 22.0013C14.1321 22.6504 13.0786 23.0009 11.996 23C10.9135 22.9992 9.86053 22.647 8.99528 21.9965C8.13004 21.346 7.49929 20.4322 7.19781 19.3925C6.89634 18.3528 6.94043 17.2434 7.32345 16.2309C7.49101 15.788 7.71946 15.374 8 15ZM10 15V5.00611C10.0099 4.64417 10.1083 4.26946 10.2694 3.94721C10.3976 3.69084 10.5742 3.46489 10.8203 3.3008C11.0602 3.14088 11.425 3 12 3C12.575 3 12.9398 3.14088 13.1797 3.3008C13.4258 3.46489 13.6024 3.69084 13.7306 3.94721C13.8911 4.26822 13.9878 4.63969 13.9998 4.99962L14 15C14 15.4069 14.0977 15.7744 14.3582 16.0973C14.5596 16.3469 14.7213 16.6284 14.8358 16.9324C15.0669 17.5463 15.0926 18.2187 14.9089 18.8485C14.7252 19.4783 14.3421 20.0315 13.8171 20.4249C13.2921 20.8183 12.6536 21.0307 11.9976 21.0301C11.3416 21.0296 10.7034 20.8162 10.1791 20.422C9.65473 20.0277 9.27248 19.474 9.08978 18.8439C8.90708 18.2138 8.9338 17.5415 9.16592 16.9279C9.28085 16.6241 9.44307 16.3428 9.64481 16.0936C9.9081 15.7683 10 15.4093 10 15Z",
    fill: "#0F0F0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.48ee537a85ec5934819d556e7c6693ab.svg";
export { ForwardRef as ReactComponent };